import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addbank',
  templateUrl: './addbank.component.html',
  styleUrls: ['./addbank.component.css']
})
export class AddbankComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
  
  formname:String="Bank"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
bankColl:any=[];
bankBO:any={};
bankid:number=0

bankform=new FormGroup({
  bankid:new FormControl(0),          
  bankname: new FormControl('', Validators.required),  
  routingcode: new FormControl('', Validators.required),  
 inactive:new FormControl(false),  
});


@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();



constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.bankid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.bankform.reset();
       this.fnInitializeFormGroup(); 

       if(this.bankid>0){
         this.fngetBank();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.bankid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  //this.firstipcontrol.first.nativeElement.focus();

  this.loginService.fnSetFirstControlFocus('txtfirst');
}

fnInitializeFormGroup(){
   this.bankform.setValue({
    bankid:0,    
     bankname: '',
     routingcode:'',
     inactive:false              
   })
}

//Get 
fngetBank() {
  if (this.showProgress) {
    return;
  }         
     var data = {
       'bankid':this.bankid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getBank(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
          this.fnHideProgress();

           this.bankColl=res.json().result;
           var editdata = this.bankColl[0];        
           this.fnEditMode(editdata);
           this.bankBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{   
      this.fnHideProgress();
       
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
      return;        
  }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.bankform.valid){
         //Check
         this.saveloading = true;
         var data = {
               'bankid': this.bankid,                      
           'bankname': this.bankform.get('bankname').value, 
               'routingcode': this.bankform.get('routingcode').value, 
               'inactive':this.bankform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckBank(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.bankform.get('bankid').value>0){
                       //Update 
                       this.fnSetBank(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertBank(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                      this.saveloading = false;

                       this.bankform.controls['bankname'].setErrors({'notfound': true});
                     }
                     else if(_checkresult==="code"){
                      this.saveloading = false;

                       this.bankform.controls['routingcode'].setErrors({'notfound': true});
                     }
               }
             }
             else {
              this.saveloading = false;

               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{
          this.saveloading = false;

             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
    this.saveloading = false;

     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertBank(data){    
 
   this.appService.fnInsertBank(data).subscribe(
     (res)=>{
      this.saveloading = false;

       if(res.json().status===200){  
         if(res.json().result!=""){

          // this.ischildkey=res.json().result[0][0].bankid;
          //this.ischildadd=true;

           this.toastr.success('', "The new bank has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.bankname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{
      this.saveloading = false;

       this.toastr.error('Error', err);
     });

}

//Set
fnSetBank(data){    

this.appService.fnSetBank(data).subscribe(
 (res)=>{
  this.saveloading = false;

   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The bank has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.bankid,data.bankname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{
  this.saveloading = false;

   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/Bank']);

  // if(this.ischild===false){
  //   this.router.navigate(['/Bank']);
  // }
  // else{
  //   var pBO:any={
  //     isadd:this.ischildadd,
  //     childkey:this.ischildkey,
  //     doctype:'BANK'    
  //   }
  //   this.childChanged.emit(pBO);
  // }

}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.bankform.setValue({ 
  bankid:deptBO.bankid,     
   bankname: deptBO.bankname,
   routingcode: deptBO.routingcode,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}

private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}







}
